<template>
  <div class="vibrationAnalyzeReports">
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination
          layout="prev, pager, next,sizes"
          :total="searchResult.total"
          :page-sizes="pageSizes"
          :page-size.sync="query.pageSize"
          :current-page.sync="query.page"
          @current-change="load"
          @size-change="load"
        ></el-pagination>
        <!-- Table -->
      </el-col>
    </el-row>
    <el-row class="tableFlex">
      <el-table
        v-loading="reportsLoading"
        :data="searchResult.reports"
        class="border"
      >
        <el-table-column
          prop="createdAt"
          :label="$t('vibration_analyze_report.date')"
        >
          <template slot-scope="scope">
            <span>
              {{ toDisplayDate(scope.row.createdAt) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="faultType"
          :label="$t('vibration_analyze_report.faultType')"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.name[$i18n.locale] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="severity"
          :label="$t('vibration_analyze_report.severity')"
        >
          <template slot-scope="scope">
            <span>
              <em
                class="color-circle"
                v-bind:style="{
                  'background-color': getColor(scope.row.severity),
                }"
              ></em>
            </span>
            {{ $t(`common.${scope.row.severity}`) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.show')"
          width="250px"
        >
          <template slot-scope="scope">
            <span style="font-size: 12px">
              <el-button
                style="margin-top: 10px; margin-right: 10px; float: left"
                size="mini"
                @click="show(scope.row)"
                >{{ $t("common.show") }}</el-button
              >
              <el-badge
                :value="$t('vibraitonAnalyzeReport.new')"
                :hidden="!(scope.row.isAnswered == false)"
                style="margin-top: 10px; margin-right: 40px; float: left"
              >
                <el-button size="mini" @click="evaluateReport(scope.row)">{{
                  $t("vibraitonAnalyzeReport.evaluate")
                }}</el-button>
              </el-badge>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination
          layout="prev, pager, next,sizes"
          :total="searchResult.total"
          :page-sizes="pageSizes"
          :page-size.sync="query.pageSize"
          :current-page.sync="query.page"
          @current-change="load"
          @size-change="load"
        ></el-pagination>
        <!-- Table -->
      </el-col>
    </el-row>

    <!-- Evaluate -->
    <div class="evaluation-container">
    <el-dialog
      width="40%"
      :visible.sync="showReportEvaluation"
      class="fault-report-evaluate-dialog"
    >
      <el-form
        v-if="activeReport"
        class="evaluation"
        ref="evaluationForm"
        :loading="evaluationLoading"
        :model="activeReport.evaluation"
        label-position="top"
      >
      <p
          style="color:black;
            letter-spacing: 0.12em;
            line-height: 29px;
            letter-spacing: 0.12em;
            --para-spacing: 0;
            text-transform: uppercase;
            font-style: normal;
            font-size: 20px;
            font-weight: 600;
            padding: 10px;
            border: 3px solid black;
            text-align: center;
          "
        >
          {{ $t("vibraitonAnalyzeReport.evaluation") }}
        </p>
        <el-form-item
          v-for="(question, i) in activeReport.info.evaluation.questions"
          v-bind:key="i"
          :rules="{
            required: question.question.isMandatory,
            message: $t('common.required'),
            trigger: 'blur',
          }"
          :prop="'questions.' + i + '.answer'"
          style="font-size:12px"
        >
        <p style="margin:0; color:#595959"><span style="font-weight:bold">{{`${i+1}. `}}</span><span>{{question.question.question[$i18n.locale]}}</span></p>
          <el-radio-group
            size="mini"
            v-if="question.question.question.tr != 'Belirtmek istedikleriniz'"
            v-model="question.question.answer"
          >
            <el-radio-button :label="true" text-color="white">{{
              $t("common.yes")
            }}</el-radio-button>
            <el-radio-button :label="false" text-color="#ffffff">{{
              $t("common.no")
            }}</el-radio-button>
          </el-radio-group>
          <el-input
            type="textarea"
            v-else
            v-model="question.question.answer"
          ></el-input>
        </el-form-item>
        <div class="evaluate-button">
        <el-form-item style="width:100%;max-width:120px">
          <el-button @click="saveEvaluation()">{{
            $t("common.save")
          }}</el-button>
        </el-form-item>
      </div>
      </el-form>
    </el-dialog>
    </div>
    <el-dialog
      width="60%"
      class="fault-report-dialog"
      title=""
      :visible.sync="previewShowForm"
    >
      <el-row>
        <el-col :span="24">
          <FaultReportView
          v-if="activeReport"
            :imageName="activeReport.image"
            :report="activeReport"
            :faultType="activeReport.faultType"
            :createdAt="activeReport.createdAt"
            :pointPath="activeReport.pointPath"
            :severity="activeReport.severity"
            :info="activeReport.info"
            :name="activeReport.name"
            v-on:download="download"
            :showDownload="true"/>
        </el-col>
      </el-row>
    </el-dialog>
    <el-row ref="fault-report" v-show="false">
        <el-col :span="24">
          <FaultReportView
          v-if="activeReport"
            :imageName="activeReport.image"
            :report="activeReport"
            :faultType="activeReport.faultType"
            :createdAt="activeReport.createdAt"
            :pointPath="activeReport.pointPath"
            :severity="activeReport.severity"
            :info="activeReport.info"
            :name="activeReport.name"
            :showDownload="false"/>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
import preferences from "../util/preferences";
// import axios from "axios";
import faultReportPdf from "./faultReportPdf.vue";
import { mapActions, mapState } from "vuex";
import { treeHelper, colorLib } from "../util";
import vibrationAnalyzeReportService from "../service/vibrationAnalyzeReport";
import FaultReportView from "./FaultReportView.vue";
import downloadPdf from '../service/downloadPdf'

export default {
  name: "VibrationAnalyzeReports",
  components: {
    faultReportPdf,
    FaultReportView,
  },
  props: ["pointId"],
  data() {
    return {
      previewShowForm: false,
      prePrintValue: "",
      showReportEvaluation: false,
      evaluationLoading: false,
      activeReport: "",
      reportEvaluation: "",
      query: {
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
    };
  },
  computed: {
    ...mapState("account", ["customer"]),
    ...mapState("tree", ["flatTree"]),
    ...mapState("vibrationAnalyzeReport", ["searchResult", "reportsLoading"]),
  },
  created() {
    //this.getTelemetry();
    this.load();
  },
  watch: {
    pointId() {
      this.load();
    },
  },

  methods: {
    show(row) {
      this.activeReport = row;
      console.log(row,'vu')
      this.previewShowForm = true;
    },
    download() {
      console.log('in',this.$refs["fault-report"])
      downloadPdf.downloadPdf(this.$refs["fault-report"].$el, 712,1150)
    },
    saveEvaluation() {
      this.evaluationLoading = true;
      // this.$refs.evaluationForm.validate((valid) => {
      //   if (valid) {
      //     this.showReportEvaluation = false;
      //     let prev = this.activeReport.isAnswered;

      //     vibrationAnalyzeReportService
      //       .saveEvaluation(this.activeReport)
      //       .then(() => {
      //         this.activeReport.isAnswered = true;
      //         if (prev != true) {
      //           this.decreaseUnansweredEvaluation(this.pointId);
      //         }
      //       })
      //       .finally(() => {
      //         this.evaluationLoading = false;
      //       });
      //   } else {
      //     return false;
      //   }
      // });
      this.showReportEvaluation = false;
      let prev = this.activeReport.isAnswered;

      vibrationAnalyzeReportService
        .saveEvaluation(this.activeReport)
        .then(() => {
          this.activeReport.isAnswered = true;
          if (prev != true) {
            this.decreaseUnansweredEvaluation(this.pointId);
          }
        })
        .finally(() => {
          this.evaluationLoading = false;
        });
    },
    getLocalizedQuestionTitle(question) {
      if (question && question.title && Object.keys(question).length) {
        return question.title[this.$i18n.locale]
          ? question.title[this.$i18n.locale]
          : question.title[Object.keys(question)[0]];
      } else {
        return "";
      }
    },
    evaluateReport(report) {
      this.activeReport = report;
      this.showReportEvaluation = true;
    },
    ...mapActions("vibrationAnalyzeReport", ["getVibrationAnalyzeReports"]),
    ...mapActions("tree", ["decreaseUnansweredEvaluation"]),
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
    pathTran(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },
    toDisplayDate(timestamp) {
      return dayjs(timestamp).format(preferences().localization.dateFormat);
    },
    load() {
      this.getVibrationAnalyzeReports({
        pointId: this.pointId,
        query: this.query,
      });
    },
    path(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },
  },
};
</script>

<style >
.el-textarea__inner{
  color:#8C8C8C !important;
  font-size:12px;
}

.el-radio-button__inner{
  color:darkgray;
}

#tab-vibrationAnalyzeReports .el-badge__content.el-badge__content.is-fixed {
  transform: translateX(12px);
}
.vibrationAnalyzeReports .evaluation label.el-form-item__label {
  width: 500px;
  line-height: 22px;
  word-break: break-word;
}
.evaluation{
  width:80%
}
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.el-table__empty-block {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}
.fault-report-dialog .el-dialog__body {
  padding: 0px !important;
}
.fault-report-dialog .el-dialog__header {
  padding: 0px !important;
}

.fault-report-evaluate-dialog .el-dialog{
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.fault-report-evaluate-dialog .el-dialog__body {
  display:flex;
  justify-content: center;
  width:100%;
}

.fault-report-evaluate-dialog .el-dialog__body button {
  background-color:#f05f22;
  color:white;
  width:100%;
  max-width: 120px;
}
.fault-report-evaluate-dialog .el-dialog__body .evaluate-button{
  display:flex;
  justify-content: center;
  width:100%;
}
.fault-report-evaluate-dialog .el-dialog__body  .el-form-item__label{
  color:#6e6e6e;
}
</style>
<style scoped>
.tableFlex {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}
.table.el-table__body {
  display: flex;
  flex-direction: column;
  max-width: 100% !important;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.color-box {
  width: 10px;
  height: 10px;
  display: inline-block;
}


</style>